(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AlbumSearch', AlbumSearch);

    AlbumSearch.$inject = ['$resource'];

    function AlbumSearch($resource) {
        var resourceUrl =  'api/_search/albums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
